export default "__VITE_ASSET__BJvLed77__"